import type { ChainFamily } from './types';
import { storageKeys } from '../config/brand';

const KEY_PREFIX = storageKeys.deployedSplitsBase;

function storageKey(family: ChainFamily, cluster: string): string {
  return `${KEY_PREFIX}:${family}:${cluster}`;
}

export function loadDeployedSplits(family: ChainFamily, cluster: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(family, cluster));
    if (!raw) return [];
    return JSON.parse(raw) as string[];
  } catch {
    return [];
  }
}

export function saveDeployedSplit(family: ChainFamily, cluster: string, address: string) {
  const existing = loadDeployedSplits(family, cluster);
  if (existing.some((a) => a.toLowerCase() === address.toLowerCase())) return;
  existing.push(address);
  try {
    localStorage.setItem(storageKey(family, cluster), JSON.stringify(existing));
  } catch {
    /* quota / private mode */
  }
}

export function removeDeployedSplit(family: ChainFamily, cluster: string, address: string) {
  const existing = loadDeployedSplits(family, cluster);
  const filtered = existing.filter((a) => a.toLowerCase() !== address.toLowerCase());
  try {
    localStorage.setItem(storageKey(family, cluster), JSON.stringify(filtered));
  } catch {
    /* quota / private mode */
  }
}

const suppressKey = (family: ChainFamily, cluster: string) => `${KEY_PREFIX}:suppress:${family}:${cluster}`;

export function suppressOnChainSplit(family: ChainFamily, cluster: string, id: string) {
  try {
    const key = suppressKey(family, cluster);
    const raw = localStorage.getItem(key);
    const list: string[] = raw ? (JSON.parse(raw) as string[]) : [];
    const lower = id.toLowerCase();
    if (list.some((x) => x.toLowerCase() === lower)) return;
    list.push(id);
    localStorage.setItem(key, JSON.stringify(list));
  } catch {
    /* ignore */
  }
}

export function loadSuppressedOnChainSplits(family: ChainFamily, cluster: string): Set<string> {
  try {
    const raw = localStorage.getItem(suppressKey(family, cluster));
    if (!raw) return new Set();
    const list = JSON.parse(raw) as string[];
    return new Set(list.map((x) => x.toLowerCase()));
  } catch {
    return new Set();
  }
}

export function unsuppressOnChainSplit(family: ChainFamily, cluster: string, id: string) {
  try {
    const key = suppressKey(family, cluster);
    const raw = localStorage.getItem(key);
    if (!raw) return;
    const lower = id.toLowerCase();
    const list = (JSON.parse(raw) as string[]).filter((x) => x.toLowerCase() !== lower);
    localStorage.setItem(key, JSON.stringify(list));
  } catch {
    /* ignore */
  }
}
